import React from 'react'

const Fifty_three = () => {
    return (
        <div className='container'>
            <h1>substring in C</h1>
           
          <p>  C substring program to find substring of a string and its all substrings. 
            A substring is itself a string that is part of a longer string. <br /> For example,
             substrings of string "the" are "" (empty string), "t", "th", "the", "h",
              "he" and "e." The header file "string.h" does not contain any library 
              function to find a substring directly. <br />
            </p>
            <div className='containers'>
           <code className='library'> #include</code> &lt;stdio.h &gt;<br/>
 
           <code className='keywords'>int</code> main()
 &#123;<br/>
 <code className='keywords'> char </code>string[1000], sub[1000];<br/>
 <code className='keywords'>int</code> position, length, c = 0;<br/>
  
 <code className='library'> printf</code>("Input a string\n");<br/>
 <code className='library'> gets</code>(string);<br/>
  
 <code className='library'>  printf</code>("Enter the position and length of substring\n");<br/>
 <code className='library'> scanf</code>("%d%d", &position, &length);<br/>
  
 <code className='keywords'>while</code> (c &lt; length) &#123;<br/>
       sub[c] = string[position+c-1];<br/>
       c++;<br/>
    &#125;<br/>
    sub[c] = '\0';<br/>
  
    <code className='library'> printf</code>("Required substring is \"%s\"\n", sub);<br/>  // '\"' to print "<br/>
  
    <code className='library'>return</code>  0;<br/>
 &#125;<br/>
            </div>
        </div>
    )
}

export default Fifty_three